import { ScreenResolutionManager } from "./Login/screenResolution";
import { IdentityProviderController } from "./Login/identityProviderController";
import { PasswordChangedController } from "./Login/passwordChangedController";

var screenResolutionManager = new ScreenResolutionManager();
var identityProviderController = new IdentityProviderController(localStorage);
var passwordChangedController = new PasswordChangedController();